module.exports = __webpack_public_path__ + "img/infrastructure-22.2c8b2c75.png";